<template>
    <Card class="summary" shadow :bordered="false" style="box-shadow: 0 2px 3px rgba(0, 0, 0, 0.11);">
        <div class="img">
            <img :src="imgSrc">
        </div>
        <div class="summary-name">
            <h4>{{item.name}}</h4>
        </div>
        <div class="count">
            <div class="item">
                <p class="tx">
                    <Icon type="md-pie"/>
                    {{$t('useRate')}}
                </p>
                <p class="val">{{run}}</p>
            </div>
            <div class="item">
                <p class="tx">
                    <Icon type="md-flash"/>
                    {{$t('powerNum')}}
                </p>
                <p class="val">{{kwh}}</p>
            </div>
            <div class="item">
                <p class="tx">
                    <Icon type="md-podium"/>
                    {{$t('finishNum')}}
                </p>
                <p class="val">{{item.finish}}/{{item.total}}</p>
            </div>
            <div class="item">
                <p class="tx">
                    <Icon type="md-pulse"/>
                    {{$t('finishRate')}}
                </p>
                <p class="val">{{finish}}</p>
            </div>
        </div>
    </Card>
</template>
<script>
export default {
    props: ['item'],
    computed: {
        run() {
            let total = this.item.run + this.item.stby + this.item.alarm + this.item.stop + this.item.off;
            if (total > 0) {
                return ((this.item.run / total) * 100).toFixed(1) + '%';
            }
            return '0.0%';
        },
        finish() {
            if (this.item.total > 0) {
                return ((this.item.finish / this.item.total) * 100).toFixed(1) + '%';
            }
            return '0.0%';
        },
        kwh() {
            if (this.item.power > 0) {
                return (this.item.power / 10).toFixed(1) + 'kwh';
            }
            return '0.0kwh';
        },
        imgSrc() {
            // console.log(this.$root.deviceKindArr[this.item.main_kind])
            return require('./../../../images/temporary/group.jpg');
        }
    }
};
</script>
<style lang="less">
.summary {
    margin-bottom: 15px;
    margin-top: -48px;
    background-color: #fff;
    display: flex;
    justify-content: space-around;
    border-radius: 3px;
    .ivu-card-body {
        display: flex;
        .img {
            width: 85px;
            height: 85px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .summary-name {
            display: flex;
            align-items: center;
            font-size: 20px;
            padding-left: 10px;
        }
        .count {
            display: flex;
            align-items: center;
            margin-left: 100px;
            .item {
                text-align: center;
                padding: 0 30px;
                border-left: 1px solid #e3e3e3;
                .tx {
                    font-size: 20px;
                    color: #777;
                }
                .val {
                    font-size: 22px;
                    font-weight: bold;
                    text-align: center;
                }
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/views/oeetable/components/summary.vue